import script from "./Right_Aside.vue?vue&type=script&setup=true&lang=js"
export * from "./Right_Aside.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__